import { isNumber } from 'lodash';

const validateOdometer = (value) => isNumber(value) && value >= 0 && value <= 185000;

export default { validateOdometer };
